const checkRound = (num: number, arr: number[]) => {
  for (let i = 0; i <= arr.length; i++) {
    if (num < arr[i]) {
      return arr[i];
    }
  }
};

export function roundUpToNearest(number) {
  const roundValues = [0.25, 0.5, 1, 2, 5, 10, 15, 20, 25, 30, 40, 50, 75, 100];
  let res;
  if (number < 100) {
    res = checkRound(number, roundValues);
  } else {
    const num = Math.ceil(number);
    const numBase = Number(num.toString().substring(0, 2));
    const numTail = num.toString().substring(2);

    const round = checkRound(numBase, roundValues);

    res = round + numTail.replace(/./g, '0');
  }

  return Number(res);
}

export const yAxisFormatter = (param: string): string => {
  const maxLength = 40;
  if (param.length > maxLength) {
    return param.slice(0, maxLength) + '...';
  }

  return String(param);
};
